<template>
	<div style="min-height: 10rem">
		<transition name="td-fade">
			<visualization-data-requesting
				v-if="isStep2 && isPreparingRequesting"
				:selectedDataList="selectedDataList"
				:isStep2="isStep2"
				:requestList.sync="requestList"
				:dimensions.sync="dimensions"
				:maxCategoryRequestNumber="maxCategoryRequestNumber"
				:dataOutput="dataOutput"
				:assignDataOutput="assignDataOutput"
				:resetDataOutput="resetDataOutput"
				:setDisabledStep1="setDisabledStep1"
				:isPreparingRequesting.sync="isPreparingRequesting"
				:rowFields.sync="rowFields"
				:columnFields.sync="columnFields"
			/>

			<visualization-main-container
				v-else-if="isStep2 && !isPreparingRequesting"
				:selectedDataList="selectedDataList"
				:isPreparingRequesting="isPreparingRequesting"
				:dataOutput="dataOutput"
				:rowFields="rowFields"
				:columnFields="columnFields"
				:dimensions="dimensions"
				:isProcessingNow="isProcessingNow"
			/>
		</transition>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import VisualizationDataRequesting from "./VisualizationStep/VisualizationDataRequesting.vue";
import VisualizationMainContainer from "./VisualizationStep/VisualizationMainContainer.vue";
import store from "../../../../store/TabelDinamisStoreV3.js";

//local registration for output component
export default {
	name: "VisualizationStep",
	data() {
		return {
			maxCategoryRequestNumber: 5,
			requestList: [],
			dimensions: [],
			dataOutput: [],
			isPreparingRequesting: true,
			rowFields: [],
			columnFields: [],
		};
	},
	props: [
		"setIsStep2",
		"isProcessingNow",
		"isStep2",
		"setDisabledStep1",
		"refreshKeySelectedDataList",
		"tempDataCart"
	],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {
		selectedDataList() {
			if (this.isProcessingNow) {
				return this.tempDataCart;
			} else {
				this.refreshKeySelectedDataList;

				return store.getSelectedDataListLocalStorageByCurrentUsername()[0]
					.items;
			}
		},
	},
	watch: {
		isStep2: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal && !newVal) {
					this.isPreparingRequesting = true;
					this.dimensions = [];
					this.requestList = [];
					this.resetDataOutput();
					this.resetRowFields();
					this.resetColumnFields();
				}
			},
			immediate: true,
		},
	},
	methods: {
		assignDataOutput(val, idx) {
			let dataOutputBackup = this.dataOutput.slice(0);
			dataOutputBackup[idx] = val;
			this.dataOutput = dataOutputBackup;
		},
		resetDataOutput() {
			this.dataOutput = [];
		},
		resetRowFields() {
			this.rowFields = [];
		},
		resetColumnFields() {
			this.columnFields = [];
		},
	},
	components: {
		"visualization-data-requesting":
			VisualizationDataRequesting,
		"visualization-main-container":
			VisualizationMainContainer,
	},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 08-09-2022 -->
